var _metadata, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2N(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 16 16",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    d: "M6 0h1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    d: "M7 0h1M6 1h2M6 2h2M6 3h2M6 4h2M6 5h2M6 6h2M6 7h2M6 8h2M6 9h2M1 10h7M0 11h2M6 11h2M0 12h1M7 12h1M1 13h1M6 13h1M2 14h4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#272727",
    d: "M2 9h4M1 12h1M6 12h1M0 13h1M7 13h1M1 14h1M6 14h1M2 15h4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2N);
export default __webpack_public_path__ + "static/media/2n.01700fe65adfe4b17695d10fd80c1fe2.svg";
export { ForwardRef as ReactComponent };